export const isStagingEnvironment = () => {
  return window.location.host.includes("staging-cap-rx");
};

export const isQAEnvironment = () => {
  return window.location.host.includes("qa-cap-rx");
};

export const isLocalEnvironment = () => {
  return window.location.hostname.match(/\d+\.\d+\.\d+\.\d+/) && window.location.port === "5000";
};

export const isDemoEnvironment = () => {
  return window.location.host.includes("demo-cap-rx");
};

export const isUATEnvironment = () => {
  return window.location.host.includes("uat-cap-rx");
};

export const isPrimeEnvironment = () => {
  return window.location.host.includes("prime-cap-rx");
};

export const isPrimeQAEnvironment = () => {
  return window.location.host.includes("primeqa-cap-rx");
};

export const isPrimeUATEnvironment = () => {
  return window.location.host.includes("primeuat-cap-rx");
};

export const isAllianceEnvironment = () => {
  return window.location.host.includes("alliance-cap-rx");
};

/**
 * Until jeffy gives us a phone number, we're turning this off in higher envs
 */
export const enableSmsMultifactorAuthentication = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};

/**
 * Feature flag for the whole multifactor authentication feature
 */
export const enableMultifactorAuthentication = () => {
  // return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isUATEnvironment() || isDemoEnvironment();
  return true;
};

export const enableMedicarePrescriptionPaymentPlan = () => {
  // return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
  return true;
};

/**
 * Feature flag for MPPP payments, not to be turned on till 1/1
 */
export const showMedicarePrescriptionPaymentPlanPaymentInfo = () => {
  // return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
  return true;
};

/**
 * Feature flag for DMR
 */
export const enableDMR = () => {
  // return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
  return !isPrimeEnvironment();
};

/**
 * Feature flag for Request Prior Authorization Renewal
 */
export const enablePriorAuthorizationRenewalRequest = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};

/**
 * Feature flag for Dental
 */
export const isDentalEnabled = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};

/**
 * Feature flag for Vision
 */
export const isVisionEnabled = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};

/**
 * Feature flag for Recent Activity Dashboard
 */
export const enableRecentActivityDashboard = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};


/**
 * Feature flag for Vision
 */
export const enableNewAccums = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};
